export default __webpack_public_path__ + "static/media/eternelle.0f0ce561.jpg";